import { render, staticRenderFns } from "./SliderSelector.vue?vue&type=template&id=2b71c8d7&"
import script from "./SliderSelector.vue?vue&type=script&lang=js&"
export * from "./SliderSelector.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports